const blogPosts = [
    {
        slug: 'how-to-choose-the-perfect-stock-photo',
        title: 'How to Choose the Perfect Stock Photo',
        excerpt: 'Not all stock photos are created equal. Here is a simple framework for picking images that feel authentic and elevate your design.',
        cover: 'https://images.unsplash.com/photo-1452421822248-d4c2b47f0c81?auto=format&fit=crop&w=1200&q=70',
        author: 'Faysal Khan',
        date: 'June 12, 2026',
        readTime: '5 min read',
        tag: 'Design',
        content: [
            'A great stock photo does not look like a stock photo. The best images feel like they were shot specifically for your project — natural lighting, real moments, and a color story that matches your brand.',
            'Start with intent. Before you search, decide what emotion the image should carry. Calm? Energetic? Trustworthy? That single word will dramatically narrow your choices and keep your visuals consistent.',
            'Next, pay attention to composition and negative space. Images with room around the subject give you space for headlines and buttons, which makes them far more flexible for hero sections and banners.',
            'Finally, keep a consistent palette. Pick two or three accent colors and favor photos that echo them. Consistency is what separates a polished site from a chaotic one.',
        ],
    },
    {
        slug: 'understanding-image-licenses',
        title: 'Understanding Image Licenses (Without the Headache)',
        excerpt: 'CC0, royalty-free, attribution — what do they actually mean? A plain-English guide so you never get a takedown notice.',
        cover: 'https://images.unsplash.com/photo-1486312338219-ce68d2c6f44d?auto=format&fit=crop&w=1200&q=70',
        author: 'Faysal Khan',
        date: 'June 3, 2026',
        readTime: '4 min read',
        tag: 'Legal',
        content: [
            'Image licensing sounds scary, but it comes down to a few simple ideas. A license is just permission — it tells you what you can and cannot do with an image.',
            'CC0 (public domain) is the most permissive: use it however you like, commercially or personally, with no attribution required. Everything on Pixiy falls under a similarly free license.',
            'Royalty-free does not mean free of cost — it means you pay once (or nothing) and can reuse the asset without paying again per use. Always read whether attribution is required.',
            'When in doubt, keep a record of where each asset came from and its license. A simple spreadsheet can save you a lot of trouble down the road.',
        ],
    },
    {
        slug: 'building-a-mood-board-that-works',
        title: 'Building a Mood Board That Actually Works',
        excerpt: 'A mood board is more than a pretty collage. Learn how to build one that guides real design decisions.',
        cover: 'https://images.unsplash.com/photo-1517430816045-df4b7de11d1d?auto=format&fit=crop&w=1200&q=70',
        author: 'Faysal Khan',
        date: 'May 24, 2026',
        readTime: '6 min read',
        tag: 'Workflow',
        content: [
            'A mood board is the bridge between a vague idea and a finished design. Done well, it aligns everyone before a single pixel is pushed.',
            'Collect broadly, then cut ruthlessly. Start with 30 images that catch your eye, then narrow to the 6 that best express the direction. The editing is where the clarity comes from.',
            'Group by theme: color, typography, texture, and photography style. Seeing them side by side reveals whether your vision is cohesive or pulling in different directions.',
            'Save your favorites as you browse — that is exactly what the heart button on Pixiy is for. Your favorites list becomes an instant, living mood board.',
        ],
    },
];

export default blogPosts;
